import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";

const KEY = ["admin", "llm-config"] as const;

export function useLlmConfig(scope?: string) {
  return useQuery({
    queryKey: [...KEY, { scope }],
    queryFn: () => api.getLlmConfig(scope),
  });
}

export function useUpsertLlmConfig(scope?: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: api.UpsertLlmPayload) => api.upsertLlmConfig(payload, scope),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useTestLlm(scope?: string) {
  return useMutation({ mutationFn: () => api.testLlm(scope) });
}
